import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/selectors';
import { useActions } from 'hooks/redux/useActions';
import {
  setUser,
  setUserIfEmpty,
  unsetUser,
} from 'redux/reducers/user-reducer';
import { getUserActivePermissions } from 'modules/get-user-active-permissions/get-user-active-permissions';

export function useUser() {
  const { data: user, status: userStatus } = useSelector(selectUser);
  const actions = useActions({
    setUser,
    unsetUser,
    setUserIfEmpty,
  });

  const permissions = useMemo(() => getUserActivePermissions(user), [user]);

  return { user, userStatus, permissions, ...actions };
}
